module.exports = __webpack_public_path__ + "img/baox.7c3a8b54.svg";